import React, { useState } from "react";
import { formatNumberToCurrency, formatNumberToLocale } from "@utils/formatNumber";

const StockAccordion = ({ item }) => {

  const Item = ({ item }) => {
    return <div key={item.creditor_name} className="accordion-item">
      <div style={{ gridTemplateColumns: "3fr 3fr 1fr", display: 'grid' }} className="accordion-item-body">
        <div className="grid">
          <span className="accordion-label">Item</span>
          <span className="accordion-title">{item?.resource_name}</span>
        </div>
        <div className="grid">
          <span className="accordion-label">Descrição</span>
          <span className="accordion-title">{item?.detail_description || item?.description}</span>
        </div>
        <div className="grid">
          <span className="accordion-label">Valor Total</span>
          <span className="accordion-title">{formatNumberToCurrency(item?.stock_total || item?.value)}</span>
        </div>
      </div>
    </div>
  }

  return <Item item={item} />
}

export default StockAccordion;